/* eslint-disable no-bitwise, no-cond-assign, no-param-reassign */
import DocumentPositions from './DocumentPositions';
import isDocument from './isDocument';
import isElement from './isElement';
/**
 * Check to see if a DOM element is a descendant of another DOM element.
 *
 * The contains() method returns `true` if the DOM element provided by
 * the second argument is a descendant of the DOM element provided by
 * the first argument, whether it is a direct child or nested more
 * deeply. Otherwise, it returns `false`. Only element nodes are
 * supported; if the second argument is a text or comment node,
 * contains() will return `false`.
 *
 * @see {@link http://ejohn.org/blog/comparing-document-position/}
 * @param parentNode DOM element that may contain the other element.
 * @param childNode DOM element that may be contained by (a descendant
 * of) the other element.
 */

export default function contains(parentNode, childNode) {
  if (parentNode == null || childNode == null) {
    return false;
  }

  if (!isElement(childNode)) {
    return false;
  }

  if (isDocument(parentNode)) {
    parentNode = parentNode.documentElement;
  }

  if (parentNode.contains != null) {
    return parentNode !== childNode && parentNode.contains(childNode);
  }

  if (parentNode.compareDocumentPosition) {
    return !!(parentNode.compareDocumentPosition(childNode) & DocumentPositions.DOCUMENT_POSITION_CONTAINED_BY);
  }

  while (childNode = childNode.parentNode) {
    if (childNode === parentNode) {
      return true;
    }
  }

  return false;
}
//# sourceMappingURL=contains.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/fraud/~/@flowio/browser-helpers/dist/esm/contains.js
// module id = 306
// module chunks = 0 1